import React from 'react';
import { Button, Col, Row, Space } from 'antd';
import { FeesFormInputs } from '../../Fees/modal-fees';
import { ChargesFormInputs } from '../../Charges/modal-charges';
import Fees from '../../Fees/fees';
import Charges from '../../Charges/charges';

type FirstStepProps = {
  goToNext: () => void;
  goToPrevious: () => void;
  fees: FeesFormInputs[];
  charges: ChargesFormInputs[];
  setFees: (data: FeesFormInputs[]) => any;
  setCharges: (data: ChargesFormInputs[]) => any;
};

const SecondStep: React.FC<FirstStepProps> = ({ fees, charges, setFees, setCharges, goToNext, goToPrevious }) => {

  return (
    <Row gutter={24}>
      <Col span={20} offset={2}>
        <Fees
          fees={ fees }
          setFees={ setFees }
        />
      </Col>
      <Col span={20} offset={2}>
        <Charges
          charges={ charges }
          setCharges={ setCharges }
        />
      </Col>
      <Col span={24} style={{ textAlign: 'center' }} >
        <Space>
          <Button onClick={ goToPrevious } >
            Anterior
          </Button>
          <Button type="primary" onClick={ goToNext } >
            Siguiente
          </Button>
        </Space>
      </Col>
    </Row>
  )
}

export default SecondStep;